<template>
  <nav class="teacher-navbar">
    <div class="nav-container">
      <div class="hstack gap-3 text-white me-auto" data-v-step="2">
        <figure class="logo d-none d-sm-flex align-items-center m-0 me-3" alt="PTC Wizard Logo">
          <Logo class="h-100" />
        </figure>

        <div
          class="select-event"
          style="cursor: pointer"
          @click="$emit('update:showEventsModal', true)"
        >
          <div type="button">
            <Typography color="white" weight="600" class="d-flex align-center gap-2">
              <span>
                {{ conferenceStore.selected?.conference_name }}
              </span>
              <span class="bi-caret-down-fill"></span>
            </Typography>
          </div>
          <Typography color="white" style="opacity: 0.7; line-height: 1" size="0.875rem">
            {{
              conferenceStore.selected?.team?.team_name ??
              `${authenticationStore.me?.teacher_fname} ${authenticationStore.me?.teacher_lname}`
            }}
          </Typography>
        </div>
      </div>

      <div class="nav-right">
        <TeacherTour />
        <div class="dropdown">
          <button
            class="btn text-white dropdown-toggle text-capitalize fs-normal px-2"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-person-fill fs-4 me-n1 d-md-none"></i>
            <span class="d-none d-md-inline-block align-middle">
              {{ authenticationStore.me?.teacher_fname }}
              {{ authenticationStore.me?.teacher_lname }}
            </span>
          </button>
          <ul
            class="dropdown-menu dropdown-menu-end"
            style="cursor: pointer"
            aria-labelledby="dropdownMenuButton1"
          >
            <li>
              <span class="dropdown-item" @click="showAccountSettings = true"
                >Account Settings</span
              >
            </li>
            <li>
              <span class="dropdown-item" @click="showDirectory = true">Directory</span>
            </li>
            <li>
              <span class="dropdown-item" @click="logout()">Log Out</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
  <ModalAccountSettings v-model:show="showAccountSettings" />
  <DirectoryModal v-model:show="showDirectory"></DirectoryModal>

  <PtcTour ref="tour" :steps="getSteps()"></PtcTour>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from "vue";

import ModalAccountSettings from "@/components/teacher/modal/AccountSettings.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useAgendaStore } from "@/stores/teacher/agenda";
import { useRoute } from "vue-router";
import { useSchoolStore } from "@/stores/school";
import Logo from "@/assets/icons/logo-vertical-knockout.svg";
import PtcTour from "@/components/teacher/PtcTour.vue";
import { useConferenceStore } from "@/stores/teacher/conference";
import Typography from "../typography.vue";
import DirectoryModal from "./modal/DirectoryModal.vue";
import TeacherTour from "./teacherTour.vue";

defineProps<{ showEventsModal: boolean }>();
defineEmits<{
  (e: 'update:showEventsModal', ...args: any[]): void
}>();

const route = useRoute();
const authenticationStore = useAuthenticationStore();
const schoolStore = useSchoolStore();
const agendaStore = useAgendaStore();
const conferenceStore = useConferenceStore();

const showAccountSettings = ref(false);
const showDirectory = ref(false);

const tour = ref<any>(null);
function getSteps() {
  console.log(route.name);
  if (tour.value && route.name == "matrix") {
    return tour.value.matrixSteps;
  } else if (tour.value && route.name == "list") {
    return tour.value.agendaSteps;
  }
}

function logout() {
  authenticationStore.logout();
  
  if (schoolStore.school?.integration == 'nycdoe' && authenticationStore.jwtData.authentication_type === 'teacher'){
    window.location.href="https://idpcloud.nycenet.edu/idaas/mtfim/sps/idaas/logout?post_logout_redirect_uri=https://app.ptcwizard.com/demo/teacher/login";
  }else{
    window.location.pathname = "/" + route.params.account + "/teacher/login";
  }
}
watch(
  () => agendaStore.loading,
  async (agendaLoading) => {
    if (!agendaLoading) {
      if (agendaStore.agenda && agendaStore.agenda.length == 0) {
        tour.value.start();
      }
    }
  }
);
onMounted(() => {
  try {
    // if (!authenticationStore.me.uid) {
    //   authenticationStore.fetchProfile();
    // }
    if (schoolStore.school == null) {
      schoolStore.loadSchool().then(() => {
        console.log("got school data again");
      });
    }
  } catch (e) {
    console.log(e);
  }
});
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.teacher-navbar {
  padding: 10px 15px;
  display: flex;
  background: linear-gradient(#4c1216, #721a1e 20%, #4b1216);

  .nav-container {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .select-event {
      height: fit-content;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      button {
        margin: 0;
        padding: 0;
      }
    }

    .nav-right {
      display: flex;
      align-items: center;
      gap: 20px;
    }
  }
}
</style>
